import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export interface RoleData {
  roleId: number;
  roleName: string;
  userRights: string;
  description: string;
}

export const getRoles = () => {
  return Http.request<RoleData[]>({
    method: 'GET',
    url: `${API_URL}/role?page=0&size=999`,
  });
};
